
    <div class="dynamic-field form-button" [formGroup]="group">
        <button class="btn btn-primary" type="submit">{{map.name}}</button>
    </div>
  